import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import type { StatementPeriodScope } from "../../../../../../../../api/types/svTypes.ts";
import type { PeriodRowOption } from "../utils/statementColumns.ts";
import PeriodRowsAutocomplete from "./PeriodRowsAutocomplete.tsx";

const NO_ROWS_NOTE = "No rows selected, so every row keeps its own period.";

const scopeOptions: { value: StatementPeriodScope; label: string }[] = [
  { value: "All", label: "Apply for All Rows" },
  { value: "Selected", label: "Apply for Selected Rows" },
];

interface Props {
  periodScope: StatementPeriodScope | undefined;
  rowOptions: PeriodRowOption[];
  selectedGuids: string[];
  readonly: boolean;
  onScopeChange: (periodScope: StatementPeriodScope) => void;
  onRowsChange: (guids: string[]) => void;
}

const DataColumnPeriodScope = ({
  periodScope,
  rowOptions,
  selectedGuids,
  readonly,
  onScopeChange,
  onRowsChange,
}: Props) => {
  const handleScopeChange = (value: string) => {
    const option = scopeOptions.find((candidate) => candidate.value === value);
    if (option) {
      onScopeChange(option.value);
    }
  };

  return (
    <Stack spacing={0.75} useFlexGap>
      <RadioGroup value={periodScope ?? "All"} onChange={(_, value) => handleScopeChange(value)} sx={{ ml: 0.75 }}>
        {scopeOptions.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio sx={{ p: 0.5 }} />}
            label={option.label}
            disabled={readonly}
            sx={{ m: 0 }}
          />
        ))}
      </RadioGroup>
      {periodScope === "Selected" && (
        <Stack spacing={0.5} useFlexGap sx={{ ml: 3.5 }}>
          <PeriodRowsAutocomplete
            options={rowOptions}
            selectedGuids={selectedGuids}
            readonly={readonly}
            onChange={onRowsChange}
          />
          {selectedGuids.length === 0 && (
            <Typography variant="caption" color="textSecondary">
              {NO_ROWS_NOTE}
            </Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default DataColumnPeriodScope;
